//HH_Gen6_PA3_vismat_opt
export const keyObjects = { //models array will be populated with the actual Object3D corresponding to the names
    EVSE: {
        modelNames: [
            ["Skydd_600mm_Assem_PA01-1"],
            ["Skydd_600mm_Assem_PA01-2"],
            ["EVSE2019_2xAssem_HH_PA6-1"],
            ["EVSE2019_2xAssem_HH_PA6-2"],
            ["EVSE2019_FotAssem_PA1-1"],
            ["EVSE2019_FotAssem_PA1-2"],
            ["Skylt_Assem_PA01-1"],
            ["100mm_Plaströr_PA1-1"]
        ],
        models: []
    },
    PV: {
        modelNames: [
            ["PV_Panels_Assem_PA1-2"],
            ["PV_Panels_Assem_PA1-1"],
            ["PV_Panels2_Assem_PA1-2"],
            ["PV_Panels2_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-2"],
            ["PV_Panels3_Assem_PA1-3"]
        ],
        models: []
    },
    PVracks: {
        modelNames: [
            ["PV_ställning-1"],
            ["PV_ställning_Liten-1"]
        ],
        models: []
    },
    Inverter: {
        modelNames: [
            ["Fronius_Assem_PA2-1"]
        ],
        models: []
    },
    Display: {
        modelNames: [
            ["Samsung_TouchScreen_PA1-1"]
        ],
        models: []
    },
    Water: {
        modelNames: [
            ["Axioma130_Ställning_Assem_PA1-1"]
        ],
        models: []
    },
    Electrical: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"],
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"],
            ["Inverter_Panel_Assem_PA1-1"],
            ["VärmeVarmVatten_Assem_PA1-1"],
            ["Elcentral_Panel_Assem_PA1-1"]
        ],
        models: []
    },
    Ventilation: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1","Body-12"],
            ["HH_Botten_Gen6_PA2-1","Body-13"]
        ],
        models: []
    },
    Heatpump: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-30"]
        ],
        models: []
    },
    Waterheater: {
        modelNames: [
            ["260L_Älyvaraja_Havetshus_PA1-1"]
        ],
        models: []
    },
    Watertank: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-29"]
        ],
        models: []
    },
    Floorheating: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1", "Body-10"],
            ["HH_Botten_Gen6_PA2-1", "Body-9"],
            ["HH_Botten_Gen6_PA2-1", "Body-8"],
            ["GolvvärmeStock_Assem_PA1-1"]
        ],
        models: []
    },
    Groundholes: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-0"],
            ["Värmepump_PA2-1", "Body-3"],
            ["Värmepump_PA2-1", "Body-27"]
        ],
        models: []
    },
    HHBotten: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1"],
        ],
        models: []
    },
    HHBotten_extra: {
        modelNames: [
            ["Dörr_Utankarm_110x230_Assem_PA1-1"],
            ["Dubbeldörr_117x230_Assem_PA1-1"],
            ["Dubbeldörr_117x230_Assem_PA1-2"],
            ["TornFönster_Nr1-1"],
            ["TornFönster_Nr2-1"],
            ["Konstsal_Fönster-1"],
            ["Kent_Fönster-1"],
            ["Entre_Dörr-1"],
            ["Fönster_1400x1880_PA1-1"],
            ["Fönster_1400x1880_PA1-2"],
            ["Fönster_1400x1880_PA1-3"],
            ["Fönster_1400x1880_PA1-4"],
            ["Räcke_PA2-1"],
            ["Berny_Fönster-1"],
            ["Fönster_2100x2180_PA1-1"],
            ["Dörr_MedKarm_Assem_PA1-1"],
            ["Dörr_110x270_Assem_PA1-1"],
            ["Havetshus_Trappa_Assem_PA1-1"],
            ["Dörr_230x2050_Assem_PA1-1"],
            ["Dörr_230x2050_Assem_PA1-2"],
            ["StoraFönsterDörr_Assem_PA1-1"],
            ["TrappSkydd_PA1-1"],
            ["StoraFönsterRutan_PA1-1"],
            ["Fanerhus_17102019_Tom_PA1-1"],
            ["Fanerhus_17102019_Tom_PA1-2"],
            ["Fanerhus_17102019_Tom_PA1-3"],
            ["Fanerhus_17102019_Tom_PA1-5"],
            ["Flaggstång_PA1-1"],
            ["Flaggstång_PA1-2"],
            ["Flaggstång_PA1-3"]
        ],
        models: []
    },
    Oculus: {
        modelNames: [
            ["Oculus_FAKRA_ASSEM_PA1-1"]
        ],
        models: []
    },
    Zodiac: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"]
        ],
        models: []
    },
    Gemini: {
        modelNames: [
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"]
        ],
        models: []
    },
    Windows: { //Just to fix the black windows with transparency, these remain untouched by opacity changes
        modelNames: [
            ["HH_Botten_Gen6_PA2-1","Windows"]
        ],
        models: []
    }

};


//Below for Gen6_PA3
/*
export const keyObjects = { //models array will be populated with the actual Object3D corresponding to the names
    EVSE: {
        modelNames: [
            ["Skydd_600mm_Assem_PA01-1"],
            ["Skydd_600mm_Assem_PA01-2"],
            ["EVSE2019_2xAssem_HH_PA6-1"],
            ["EVSE2019_2xAssem_HH_PA6-2"],
            ["EVSE2019_FotAssem_PA1-1"],
            ["EVSE2019_FotAssem_PA1-2"],
            ["Skylt_Assem_PA01-1"],
            ["100mm_Plaströr_PA1-1"]
        ],
        models: []
    },
    PV: {
        modelNames: [
            ["PV_Panels_Assem_PA1-2"],
            ["PV_Panels_Assem_PA1-1"],
            ["PV_Panels2_Assem_PA1-2"],
            ["PV_Panels2_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-2"],
            ["PV_Panels3_Assem_PA1-3"]
        ],
        models: []
    },
    PVracks: {
        modelNames: [
            ["PV_ställning-1"],
            ["PV_ställning_Liten-1"]
        ],
        models: []
    },
    Inverter: {
        modelNames: [
            ["Fronius_Assem_PA2-1"]
        ],
        models: []
    },
    Display: {
        modelNames: [
            ["Samsung_TouchScreen_PA1-1"]
        ],
        models: []
    },
    Water: {
        modelNames: [
            ["Axioma130_Ställning_Assem_PA1-1"]
        ],
        models: []
    },
    Electrical: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"],
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"],
            ["Inverter_Panel_Assem_PA1-1"],
            ["VärmeVarmVatten_Assem_PA1-1"],
            ["Elcentral_Panel_Assem_PA1-1"]
        ],
        models: []
    },
    Ventilation: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1","Body-12"],
            ["HH_Botten_Gen6_PA2-1","Body-13"],
            ["Fläktkåpa_Rund_PA1-1"],
            ["Fläktkåpa_Rund_PA1-2"],
            ["Fläktkåpa_Rund_PA1-3"],
            ["Fläktkåpa_Rund_PA1-4"],
            ["Fläktgaller-1"],
            ["Ventilations_Ritilä_PA2-2"],
            ["Ventilations_Ritilä_PA2-1"],
            ["Ventilations_galler_500x230_PA1-2"],
            ["Ventilations_galler_500x230_PA1-3"],
            ["Ventilations_galler_500x230_PA1-4"],
            ["Ventilations_galler_500x230_PA1-5"],
            ["Ventilations_galler_500x230_PA1-6"],
            ["Ventilations_galler_500x230_PA1-7"],
            ["Ventilations_galler_500x230_PA1-8"],
            ["Ventilations_galler_500x230_PA1-9"]
        ],
        models: []
    },
    Heatpump: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-30"]
        ],
        models: []
    },
    Waterheater: {
        modelNames: [
            ["260L_Älyvaraja_Havetshus_PA1-1"]
        ],
        models: []
    },
    Watertank: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-29"]
        ],
        models: []
    },
    Floorheating: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1", "Body-10"],
            ["HH_Botten_Gen6_PA2-1", "Body-9"],
            ["HH_Botten_Gen6_PA2-1", "Body-8"],
            ["GolvvärmeStock_Assem_PA1-1"]
        ],
        models: []
    },
    Groundholes: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-0"],
            ["Värmepump_PA2-1", "Body-3"],
            ["Värmepump_PA2-1", "Body-27"]
        ],
        models: []
    },
    HHBotten: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1"],
        ],
        models: []
    },
    HHBotten_extra: {
        modelNames: [
            ["Dörr_Utankarm_110x230_Assem_PA1-1"],
            ["Dubbeldörr_117x230_Assem_PA1-1"],
            ["Dubbeldörr_117x230_Assem_PA1-2"],
            ["TornFönster_Nr1-1"],
            ["TornFönster_Nr2-1"],
            ["Konstsal_Fönster-1"],
            ["Kent_Fönster-1"],
            ["Entre_Dörr-1"],
            ["Fönster_1400x1880_PA1-1"],
            ["Fönster_1400x1880_PA1-2"],
            ["Fönster_1400x1880_PA1-3"],
            ["Fönster_1400x1880_PA1-4"],
            ["Räcke_PA2-1"],
            ["Berny_Fönster-1"],
            ["Fönster_2100x2180_PA1-1"],
            ["Dörr_MedKarm_Assem_PA1-1"],
            ["Dörr_110x270_Assem_PA1-1"],
            ["Havetshus_Trappa_Assem_PA1-1"],
            ["Dörr_230x2050_Assem_PA1-1"],
            ["Dörr_230x2050_Assem_PA1-2"],
            ["StoraFönsterDörr_Assem_PA1-1"],
            ["TrappSkydd_PA1-1"],
            ["StoraFönsterRutan_PA1-1"],
            ["Fanerhus_17102019_Tom_PA1-1"],
            ["Fanerhus_17102019_Tom_PA1-2"],
            ["Fanerhus_17102019_Tom_PA1-3"],
            ["Fanerhus_17102019_Tom_PA1-5"],
            ["Flaggstång_PA1-1"],
            ["Flaggstång_PA1-2"],
            ["Flaggstång_PA1-3"]
        ],
        models: []
    },
    Oculus: {
        modelNames: [
            ["Oculus_FAKRA_ASSEM_PA1-1"]
        ],
        models: []
    },
    Zodiac: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"]
        ],
        models: []
    },
    Gemini: {
        modelNames: [
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"]
        ],
        models: []
    }

};
*/

/*export const keyObjects = { //models array will be populated with the actual Object3D corresponding to the names
    EVSE: {
        modelNames: [
            ["HH_evse_merged"],
            ["EVSE2019_2xAssem_HH_PA6-1"],
            ["EVSE2019_2xAssem_HH_PA6-2"],
            ["100mm_Plaströr_PA1-1"]
        ],
        models: []
    },
    PV: {
        modelNames: [
            ["PV_Panels_Assem_PA1-2"],
            ["PV_Panels_Assem_PA1-1"],
            ["PV_Panels2_Assem_PA1-2"],
            ["PV_Panels2_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-2"],
            ["PV_Panels3_Assem_PA1-3"]
        ],
        models: []
    },
    PVracks: {
        modelNames: [
            ["PV_ställning-1"],
            ["PV_ställning_Liten-1"]
        ],
        models: []
    },
    Inverter: {
        modelNames: [
            ["Fronius_Symo_RED_Assem_PA2-1"],
            ["Fronius_Battery_Assem_PA2-1"],
            ["Fronius_Symo_Assem_PA2-1"]
        ],
        models: []
    },
    Display: {
        modelNames: [
            ["Samsung_TouchScreen_PA1-1"]
        ],
        models: []
    },
    Water: {
        modelNames: [
            ["Axioma130_Ställning_Assem_PA1-1"]
        ],
        models: []
    },
    Electrical: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"],
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"],
            ["Inverter_Panel_Assem_PA1-1"],
            ["VärmeVarmVatten_Assem_PA1-1"],
            ["Elcentral_Panel_Assem_PA1-1"]
        ],
        models: []
    },
    Ventilation: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1","Body-12"],
            ["HH_Botten_Gen6_PA2-1","Body-13"],
            ["HH_vent_merged"]
        ],
        models: []
    },
    Heatpump: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-2"]
        ],
        models: []
    },
    Waterheater: {
        modelNames: [
            ["260L_Älyvaraja_Havetshus_PA1-1"]
        ],
        models: []
    },
    Watertank: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-25"]
        ],
        models: []
    },
    Floorheating: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1", "Body-8"] //Need to split golvvärmestock
        ],
        models: []
    },
    Groundholes: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-29"]
        ],
        models: []
    },
    HHBotten: {
        modelNames: [
            ["HH_body_merged"]
        ],
        models: []
    }
};*/

//Below for Gen6_PA2
/*
export const keyObjects = { //models array will be populated with the actual Object3D corresponding to the names
    EVSE: {
        modelNames: [
            ["Skydd_600mm_Assem_PA01-1"],
            ["Skydd_600mm_Assem_PA01-2"],
            ["EVSE2019_2xAssem_HH_PA6-1"],
            ["EVSE2019_2xAssem_HH_PA6-2"],
            ["EVSE2019_FotAssem_PA1-1"],
            ["EVSE2019_FotAssem_PA1-2"],
            ["Skylt_Assem_PA01-1"],
            ["100mm_Plaströr_PA1-1"]
        ],
        models: []
    },
    PV: {
        modelNames: [
            ["PV_Panels_Assem_PA1-2"],
            ["PV_Panels_Assem_PA1-1"],
            ["PV_Panels2_Assem_PA1-2"],
            ["PV_Panels2_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-1"],
            ["PV_Panels3_Assem_PA1-2"],
            ["PV_Panels3_Assem_PA1-3"]
        ],
        models: []
    },
    PVracks: {
        modelNames: [
            ["PV_ställning-1"],
            ["PV_ställning_Liten-1"]
        ],
        models: []
    },
    Inverter: {
        modelNames: [
            ["Fronius_Symo_RED_Assem_PA2-1"],
            ["Fronius_Battery_Assem_PA2-1"],
            ["Fronius_Symo_Assem_PA2-1"]
        ],
        models: []
    },
    Display: {
        modelNames: [
            ["Samsung_TouchScreen_PA1-1"]
        ],
        models: []
    },
    Water: {
        modelNames: [
            ["Axioma130_Ställning_Assem_PA1-1"]
        ],
        models: []
    },
    Electrical: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"],
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"],
            ["Inverter_Panel_Assem_PA1-1"],
            ["VärmeVarmVatten_Assem_PA1-1"],
            ["Elcentral_Panel_Assem_PA1-1"]
        ],
        models: []
    },
    Ventilation: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1","Body-12"],
            ["HH_Botten_Gen6_PA2-1","Body-13"],
            ["Fläktkåpa_Rund_PA1-1"],
            ["Fläktkåpa_Rund_PA1-2"],
            ["Fläktkåpa_Rund_PA1-3"],
            ["Fläktkåpa_Rund_PA1-4"],
            ["Fläktgaller-1"],
            ["Ventilations_Ritilä_PA2-2"],
            ["Ventilations_Ritilä_PA2-1"],
            ["Ventilations_galler_500x230_PA1-2"],
            ["Ventilations_galler_500x230_PA1-3"],
            ["Ventilations_galler_500x230_PA1-4"],
            ["Ventilations_galler_500x230_PA1-5"],
            ["Ventilations_galler_500x230_PA1-6"],
            ["Ventilations_galler_500x230_PA1-7"],
            ["Ventilations_galler_500x230_PA1-8"],
            ["Ventilations_galler_500x230_PA1-9"]
        ],
        models: []
    },
    Heatpump: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-2"]
        ],
        models: []
    },
    Waterheater: {
        modelNames: [
            ["260L_Älyvaraja_Havetshus_PA1-1"]
        ],
        models: []
    },
    Watertank: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-25"]
        ],
        models: []
    },
    Floorheating: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1", "Body-10"],
            ["HH_Botten_Gen6_PA2-1", "Body-9"],
            ["HH_Botten_Gen6_PA2-1", "Body-8"],
            ["GolvvärmeStock_Assem_PA1-1"]
        ],
        models: []
    },
    Groundholes: {
        modelNames: [
            ["Värmepump_PA2-1", "Body-29"],
            ["Värmepump_PA2-1", "Body-30"],
            ["Värmepump_PA2-1", "Body-31"]
        ],
        models: []
    },
    HHBotten: {
        modelNames: [
            ["HH_Botten_Gen6_PA2-1"]
        ],
        models: []
    },
    Oculus: {
        modelNames: [
            ["Oculus_FAKRA_ASSEM_PA1-1"]
        ],
        models: []
    },
    Zodiac: {
        modelNames: [
            ["ZMF_HH_Huvudmätare_PA1-1"]
        ],
        models: []
    },
    Gemini: {
        modelNames: [
            ["Gemini_Havetshus_PA1-1"],
            ["Gemini_Havetshus_PA1-2"]
        ],
        models: []
    }

};
*/